module.exports = __webpack_public_path__ + "img/reset-password-v2.a03a413f.svg";